<script setup>

import MainLayout from "@/Layouts/MainLayout.vue";
import { Head }  from '@inertiajs/vue3';
import { contact_information } from "~app_root/public/tv/app.config";
import {Link}  from '@inertiajs/vue3';

</script>

<template>

	<MainLayout>

		<Head>
			<title head-key="title">{{__('404_title')}}</title>
			<meta name="description" content="Pagina nu a fost gasita" head-key="description"/>
		</Head>

		<div class="container text-center">
			<h1 class='text-center mb-4 mt-5'>{{__('404_title')}}</h1>

			<p class="mb-2">{{__('404_description')}}</p>
			<p class="mb-4">{{__('need_help')}}</p>
			<a v-for="phone in contact_information.phones" :href="'tel:' + phone.value" class="mx-1">{{phone.label}}</a>

			<Link :href="'tel:' + contact_information.email">{{contact_information.email}}</Link>

		</div>

	</MainLayout>

</template>

<script>

export default {
	name: "Page"
}
</script>

<style scoped>

</style>